export enum EventsName {
  SAVE_BO_NOTES_CLICKED = "save_bo_notes_clicked",
  ORDER_CLICKED = "order_clicked",
  EV_SCREEN_VIEWED = "ev_screen_viewed",
  INSURANCE_TAB_SELECTED = "insurance_tab_selected",
  VALIDATE_EV_CLICKED = "validate_ev_clicked",
  CLOSE_BUTTON_CLICKED = "close_button_clicked",
  REFRESH_BUTTON_CLICKED = "refresh_button_clicked",
  CONTINUE_BUTTON_CLICKED = "continue_button_clicked",
  GO_BACK_BUTTON_CLICKED = "go_back_button_clicked",
  AUTH_STATUS_SCREEN_SHOWN = "auth_status_screen_shown",
  AUTH_TAB_SELECTED = "auth_tab_selected",
  TRIGGER_RPA_CLICKED = "trigger_rpa_clicked",
  RADIO_BUTTON_CLICKED = "radio_button_clicked",
  CLICKED_ON_BUSINESS_OFFICE = "clicked_on_business_office",
  BUSINESS_OFFICE_EDITED = "business_office_edited",
  RADIO_BUTTON_SELECTED = "radio_button_selected",
  MARK_AS_COMPLETED_BUTTON_CLICKED = "mark_as_completed_button_clicked",
  SAVE_BUTTON_CLICKED = "save_button_clicked",
  EDITABLE_TEXT_CELL_CLICKED = "editable_text_cell_clicked",
  AUTH_STATUS_DROPDOWN_SELECTED = "auth_status_dropdown_selected",
  SIDE_NAV_CLICKED = "side_nav_clicked",
  RAISE_QUERY_MODAL_OPENED = "raise_query_modal_opened",
  RAISE_QUERY_EDITED = "raise_query_edited",
  NAR_LETTER_UPLOAD = "nar_letter_uploaded",
  APPROVAL_LETTER_UPLOAD = "approval_letter_uploaded",
  FILLED_FORM_UPLOAD = "filled_form_uploaded",
  DENIAL_LETTER_UPLOAD = "denial_letter_uploaded",
  NAR_LETTER_VIEWED = "nar_letter_viewed",
  APPROVAL_LETTER_VIEWED = "approval_letter_viewed",
  FILLED_FORM_VIEWED = "filled_form_viewed",
  DENIAL_LETTER_VIEWED = "denial_letter_viewed",
  NAR_LETTER_DELETED = "nar_letter_deleted",
  APPROVAL_LETTER_DELETED = "approval_letter_deleted",
  FILLED_FORM_DELETED = "filled_form_deleted",
  DENIAL_LETTER_DELETED = "denial_letter_deleted",
  START_FILING_CLICKED = "start_filing_clicked",
  FORM_SELECTED = "form_selected",
  FORM_SCREEN_SHOWN = "form_screen_shown",
  SUBMIT_FORM_CLICKED = "submit_form_clicked",
  MANAGE_ATTACHMENTS_CLICKED = "manage_attachments_clicked",
  SUBMISSION_STATUS_SCREEN_SHOWN = "submission_status_screen_shown",
  WORKLIST_SCREEN_SHOWN = "worklist_screen_shown",
  MODAL_SHOWN = "modal_shown",
  REPORT_INACCURACY_CLICKED = "report_inaccuracy_clicked",
  INACCURACY_SAVED = "inaccuracy_saved",
  CHECK_BOX_CLICKED = "check_box_clicked",
  FORM_FIELD_EDITED = "form_field_edited",
  ADD_MORE_CLICKED = "add_more_clicked",
  DELETE_CLICKED = "delete_clicked",
  CLINICAL_DOCUMENT_CLICKED = "clinical_document_clicked",
  DOWNLOAD_BUTTON_CLICKED = "download_button_clicked",
  VIEW_NCCN_GUIDELINES_CLICKED = "view_nccn_guidelines_clicked",
  GUIDELINE_TAB_SELECTED = "guideline_tab_selected",
  GUIDELINE_VIEWED = "guideline_viewed",
  ADD_MORE_DOCUMENTS_CLICKED = "add_more_documents_clicked",
  DELETE_DOCUMENT_CLICKED = "delete_document_clicked",
  UPLOADING_ATTACHMENT_COMPLETED = "uploading_attachment_completed",
  SUBMISSION_INITIATED = "submission_initiated",
  VIEW_SCREENSHOT_CLICKED = "view_screenshot_clicked",
  FROM_DATE_CLICKED = "from_date_clicked",
  TO_DATE_CLICKED = "to_date_clicked",
  J_CODE_CLICKED = "j_code_clicked",
  VISITS_CLICKED = "total_visits_clicked",
  VISITS_ALLOWED_CLICKED = "completed_visits_clicked",
  VISITS_REMAINING_CLICKED = "visits_remaining_clicked",
  FROM_DATE_CHANGED = "from_date_changed",
  TO_DATE_CHANGED = "to_date_changed",
  J_CODE_CHANGED = "j_code_changed",
  VISITS_CHANGED = "total_visits_changed",
  VISITS_ALLOWED_CHANGED = "completed_visits_changed",
  VISITS_REMAINING_CHANGED = "visits_remaining_changed",
  AUTH_STATUS_DROPDOWN_CLICKED = "auth_status_dropdown_clicked",
  UPLOAD_DOCUMENT_BUTTON_CLICKED = "upload_document_button_clicked",
  DOCUMENT_TITLE_UPDATED = "document_title_updated",
  UPLOAD_DOCUMENT = "upload_document",
  MARK_AS_COMPLETED_BUTTON_SAVED = "mark_as_completed_button_saved",
  J_CODE_STATUS = "j_code_status",
  UPDATE_J_CODES_AUTH_STATUS_INITIATED = "update_j_codes_auth_status_initiated",
  WRITE_BACK_NOTES_INITIATED = "write_back_notes_initiated",
  DOCUMENT_UPLOAD_INITIATED = "document_upload_initiated",
  VIEW_TX_PLAN_CLICKED = "view_tx_plan_clicked",
  VALIDATE_EV_OPTION_SELECTED = "validate_ev_option_selected",
  HAPPY_FLOW_MODAL_OPENED = "happy_flow_modal_opened",
  COMMENT_RPA_MODAL_NEW_OPENED = "comment_rpa_modal_new_opened",
  COMMENT_RPA_MODAL_CHECKBOX_CHECKED = "comment_rpa_modal_checkbox_checked",
  COMMENT_RPA_MODAL_RADIO_BUTTON_CLICKED = "comment_rpa_modal_radio_button_clicked",
  COMMENT_RPA_MODAL_DROPDOWN_SELECTED = "comment_rpa_modal_dropdown_selected",
  COMMENT_RPA_MODAL_DROPDOWN_CLICKED = "comment_rpa_modal_dropdown_clicked",
  TRIGGER_RPA_CLICKED_NAR = "trigger_rpa_clicked_nar",
  SETTINGS_CLICKED = "settings_clicked",
  LOGOUT = "logout",
  LOGIN = "login",
  CLICKED_ON_FILTER = "clicked_on_filter",
  OPEN_FILTER = "open_filter",
  SEARCH_BAR_CLICKED = "search_bar_clicked",
  ASSIGNED_TO_CLICKED = "assigned_to_clicked",
  ASSIGNED_TO_SAVE_CLICKED = "assigned_to_save_clicked",
  BULK_ASSIGN_BUTTON_CLICKED = "bulk_assign_button_clicked",
  BULK_ASSIGN_BUTTON_SAVE_CLICKED = "bulk_assign_button_save_clicked",
  NCCN_CONFIG_MISSING = "no_match",
  DRUG_PREFERENCE = "non_preferred",
  PRIMARY_ICD_EDIT_BUTTON_CLICKED = "primary_icd_edit_button_clicked",
  PRIMARY_ICD_REFRESH_BUTTON_CLICKED = "primary_icd_refresh_button_clicked",
  PRIMARY_ICD_SAVED = "primary_icd_saved",
  DX_CODE_DROPDOWN_SELECTED = "dx_code_dropdown_selected",
  ORDER_MENU_CLICKED = "order_menu_clicked",
  VIEW_NAR_CLIKCED = "view_nar_clicked",
  VIEW_GUIDELINES_CLICKED = "view_guidelines_clicked",
  VIEW_DX_CODES_CLICKED = "view_dx_codes_clicked",
  VIEW_IN_ONCO_EMR_CLICKED = "view_in_onco_emr_clicked",
  VIEW_CHECK_VISITS_CAUTIOUSLY = "view_check_visits_cautiously",
  AUTH_LETTERS_TAB_VIEW = "auth_letters_tab_view",
  AUTH_LETTERS_FETCHED = "auth_letters_fetched",
  AUTH_LETTER_VIEW_CLICKED = "auth_letter_view_clicked",
}
